export default "__VITE_ASSET__DFZkEKXT__"